import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { updateCurrentUser } from 'actions/users';

import { ThemeContext } from 'context/ThemeContext';

import { useCurrentTeamId } from 'shared-hooks/team';

import IconStar from 'icons/icon-star';
import IconDay from 'icons/icon-day';
import IconNight from 'icons/icon-night';

import './ThemeSwitch.styles.css';

const THEMES = [
    {
        id: 'light',
        icon: <IconStar />
    },
    {
        id: 'full_light',
        icon: <IconDay />
    },
    {
        id: 'dark',
        icon: <IconNight />
    }
];

const Item = ({ id, title, icon, isSelected, onClick }) => {
    const handleClick = () => onClick(id);

    return (
        <div className={'theme-switch-item' + (isSelected ? ' selected' : '')} onClick={handleClick}>
            <div className="item-icon">
                { icon }
            </div>

            <div className="item-title">
                { title }
            </div>
        </div>
    );
}

const ThemeSwitch = () => {
    const { t } = useTranslation('settings');
    const themeCtx = useContext(ThemeContext);
    const currentTeamId = useCurrentTeamId();

    const handleThemeSelect = nextTheme => {
        updateCurrentUser({
            theme: nextTheme,
            team_id: currentTeamId
        });
    }

    return (
        <div className="theme-switch">
            {
                THEMES.map(theme => (
                    <Item
                        key={theme.id}
                        id={theme.id}
                        title={t(`themes.labelsShort.${theme.id}`)}
                        icon={theme.icon}
                        isSelected={themeCtx?.theme === theme.id}
                        onClick={handleThemeSelect}
                    />
                ))
            }
        </div>
    );
}

export default ThemeSwitch;
